(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_nuture-lst-stickybar"] && !Shopify.designMode) return;
  try {
    // Publica a altura da barra para o rodapé reservar o espaço exato. Sem isto
  // o aviso legal do fim da página fica coberto, e um valor fixo no CSS erra
  // assim que a copy da barra muda de tamanho.
  (() => {
    const bar = document.querySelector('.nuture-lst-stickybar');
    if (!bar) return;

    const publish = () => {
      document.documentElement.style.setProperty(
        '--nuture-lst-stickybar-height',
        `${Math.ceil(bar.getBoundingClientRect().height)}px`,
      );
    };

    publish();
    if ('ResizeObserver' in window) new ResizeObserver(publish).observe(bar);
    else window.addEventListener('resize', publish, { passive: true });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["nuture-kit-selector"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('rf-kit-selector')) {
    class RFKitSelector extends HTMLElement {
      connectedCallback() {
        this.options = Array.from(this.querySelectorAll('.rf-kit-option'));
        this.cta = this.querySelector('[data-action="checkout"]');
        this.defaultMarker = this.querySelector('.rf-kit-selector__default');
        this.selected = null;
        this.isProcessing = false;

        if (this.options.length === 0) return;

        this.options.forEach((opt) => {
          opt.addEventListener('click', () => this.select(opt));
        });

        // Seleção inicial: slug default injetado pelo Liquid, senão primeiro
        const wanted = this.defaultMarker ? this.defaultMarker.dataset.defaultSlug : null;
        const initial = this.options.find((o) => o.dataset.slug === wanted) || this.options[0];
        if (initial) this.select(initial, { silent: true });

        if (this.cta) {
          this.cta.addEventListener('click', () => this.handleCheckout());
        }
      }

      /**
       * API pública: slug do kit atualmente selecionado.
       * Consumido por blocos externos como RF-004 (Sticky Buy Bar).
       */
      get selectedSlug() {
        return this.selected ? this.selected.dataset.slug : null;
      }

      select(opt, options) {
        options = options || {};
        this.options.forEach((o) => {
          const on = o === opt;
          o.classList.toggle('is-selected', on);
          o.setAttribute('aria-checked', on ? 'true' : 'false');
        });
        this.selected = opt;

        // Dispara evento pra blocos externos escutarem mudanças
        // (a menos que seja a seleção inicial silenciosa no connectedCallback).
        if (!options.silent) {
          this.dispatchEvent(
            new CustomEvent('rf-kit-selector:change', {
              detail: { slug: this.selectedSlug },
              bubbles: true,
            }),
          );
        }
      }

      /**
       * Mostra uma mensagem de erro visível abaixo do CTA (role="alert"
       * pra leitores de tela anunciarem). Fail-closed deixa de ser silencioso.
       */
      showError(message) {
        if (!this._errorEl) {
          this._errorEl = document.createElement('p');
          this._errorEl.className = 'rf-kit-selector__error';
          this._errorEl.setAttribute('role', 'alert');
          if (this.cta && this.cta.parentNode) {
            this.cta.insertAdjacentElement('afterend', this._errorEl);
          } else {
            this.appendChild(this._errorEl);
          }
        }
        this._errorEl.textContent = message;
      }

      async handleCheckout() {
        if (!this.selected || this.isProcessing) return;
        const slug = this.selected.dataset.slug;

        // Detecção runtime do primitivo. Se não estiver disponível,
        // desabilita o CTA (fail-closed) — sem fallback pra Astro.
        if (!window.RafobaseCart || typeof window.RafobaseCart.addOffer !== 'function') {
          console.error(
            '[RF-003] window.RafobaseCart.addOffer não disponível. ' +
              'Habilite o app embed "Rafobase Cart" em Personalizar tema → App embeds.',
          );
          this.cta.disabled = true;
          this.showError('Não foi possível iniciar a compra. Recarregue a página e tente novamente.');
          return;
        }

        this.isProcessing = true;
        this.cta.disabled = true;
        this.cta.dataset.loading = 'true';

        try {
          await window.RafobaseCart.addOffer(slug);
        } catch (err) {
          // O primitivo já chama console.error. Fail-closed: mantém o CTA
          // desabilitado por um curto período pra evitar retry impulsivo,
          // depois reabilita pra permitir nova tentativa.
          console.error('[RF-003] addOffer rejeitado:', err);
          setTimeout(() => {
            this.cta.disabled = false;
          }, 1500);
        } finally {
          this.isProcessing = false;
          delete this.cta.dataset.loading;
          setTimeout(() => {
            this.cta.disabled = false;
          }, 300);
        }
      }
    }
    customElements.define('rf-kit-selector', RFKitSelector);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["nuture-offer-drawer"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('rf-offer-drawer')) {
    function normalizeImgUrl(url) {
      if (!url) return '';
      const s = String(url);
      if (s.startsWith('//')) return 'https:' + s;
      return s;
    }

    // Cache global de /products.json — indexado uma vez por sessão da página
    if (!window.__rfProductsIndex) {
      window.__rfProductsIndex = null;
      window.__rfProductsIndexPromise = null;
    }

    async function loadProductsIndex() {
      if (window.__rfProductsIndex) return window.__rfProductsIndex;
      if (window.__rfProductsIndexPromise) return window.__rfProductsIndexPromise;

      window.__rfProductsIndexPromise = fetch('/products.json?limit=250', { credentials: 'same-origin' })
        .then((r) => (r.ok ? r.json() : { products: [] }))
        .then((data) => {
          const products = Array.isArray(data.products) ? data.products : [];
          const byVariantId = new Map();
          products.forEach((p) => {
            if (!Array.isArray(p.variants)) return;
            p.variants.forEach((v) => {
              byVariantId.set(String(v.id), p);
            });
          });
          window.__rfProductsIndex = byVariantId;
          return byVariantId;
        })
        .catch((err) => {
          console.warn('[RF-007] Falha ao carregar /products.json:', err);
          window.__rfProductsIndex = new Map();
          return window.__rfProductsIndex;
        });
      return window.__rfProductsIndexPromise;
    }

    function extractProductImage(p) {
      if (!p) return '';
      // /products.json retorna image (primária) e images[]
      if (p.image) {
        if (typeof p.image === 'string') return normalizeImgUrl(p.image);
        if (p.image.src) return normalizeImgUrl(p.image.src);
      }
      if (Array.isArray(p.images) && p.images.length > 0) {
        const first = p.images[0];
        if (typeof first === 'string') return normalizeImgUrl(first);
        if (first && first.src) return normalizeImgUrl(first.src);
      }
      if (p.featured_image) {
        if (typeof p.featured_image === 'string') return normalizeImgUrl(p.featured_image);
        if (p.featured_image.src) return normalizeImgUrl(p.featured_image.src);
      }
      return '';
    }

    function extractVariantImage(p, variantId) {
      // Tenta imagem específica da variante primeiro
      if (!p || !Array.isArray(p.variants)) return '';
      const variant = p.variants.find((v) => String(v.id) === String(variantId));
      if (variant && variant.featured_image) {
        if (typeof variant.featured_image === 'string') return normalizeImgUrl(variant.featured_image);
        if (variant.featured_image.src) return normalizeImgUrl(variant.featured_image.src);
      }
      return '';
    }

    async function resolveVariant(variantId) {
      const index = await loadProductsIndex();
      const product = index.get(String(variantId));
      if (!product) {
        return { product: null, name: '', image: '' };
      }
      const variantImg = extractVariantImage(product, variantId);
      const image = variantImg || extractProductImage(product);
      return {
        product,
        name: product.title || '',
        image,
      };
    }

    function gidToId(gid) {
      const m = String(gid || '').match(/(\d+)$/);
      return m ? m[1] : null;
    }

    function moneyBRL(n) {
      // Sem centavos, como o checkout ("R$ 288/mês") — densidade no mobile
      return 'R$ ' + Math.round(Number(n)).toLocaleString('pt-BR');
    }

    class RFOfferDrawer extends HTMLElement {
      connectedCallback() {
        this.drawerId = this.dataset.drawerId;
        this.dialog = this.querySelector('.rf-offer-drawer__dialog');
        if (!this.dialog) return;

        this.plans = Array.from(this.querySelectorAll('.rf-drawer-plan'));
        this.cta = this.querySelector('[data-action="checkout"]');
        this.guarantee = this.querySelector('[data-guarantee]');
        this.guaranteeVariants = Array.from(this.querySelectorAll('[data-guarantee-mode]'));
        this.defaultMarker = this.querySelector('.rf-offer-drawer__default');
        this.selected = null;
        this.isProcessing = false;
        this.redirecting = false;
        this.checkoutFlow = this.dataset.checkoutFlow || 'drawer';
        this.hydrated = false;

        // Registro global pra RF-008 encontrar
        if (!window.__rfDrawers) window.__rfDrawers = new Map();
        window.__rfDrawers.set(this.drawerId, this);

        // Listeners globais pra abertura via data-attribute
        this.openHandler = (e) => {
          const trigger = e.target.closest('[data-rf-drawer-open]');
          if (!trigger) return;
          const wanted = trigger.dataset.rfDrawerOpen;
          if (wanted === this.drawerId) {
            e.preventDefault();
            this.open();
          }
        };
        document.addEventListener('click', this.openHandler);

        // Fechar via botão interno ou clique no backdrop
        this.dialog.addEventListener('click', (e) => {
          if (e.target.closest('[data-rf-drawer-close]')) {
            this.close();
            return;
          }
          // Clique no backdrop (o próprio dialog, não o painel)
          if (e.target === this.dialog) {
            this.close();
          }
        });

        // ESC: intercepta o cancel nativo pra fechar com animação
        this.dialog.addEventListener('cancel', (e) => {
          e.preventDefault();
          this.close();
        });

        // ESC nativo do <dialog> chama 'close' event
        this.dialog.addEventListener('close', () => {
          document.documentElement.style.overflow = '';
        });

        // Seleção de plano
        this.plans.forEach((plan) => {
          plan.addEventListener('click', () => this.select(plan));
        });

        // Seleção inicial
        const wanted = this.defaultMarker ? this.defaultMarker.dataset.defaultSlug : null;
        const initial = this.plans.find((p) => p.dataset.slug === wanted) || this.plans[0];
        if (initial) this.select(initial);

        if (this.cta) {
          this.cta.addEventListener('click', () => this.handleCheckout());
        }

        // Fecha se o carrinho for atualizado (usuário adicionou algo)
        this.offerAddedHandler = () => {
          if (this.dialog.open) this.close();
        };
        document.addEventListener('rafobase:offer:added', this.offerAddedHandler);

        // Pré-hidrata em idle: o conteúdo fica pronto antes do primeiro open,
        // então o slide-up anima um painel já montado (sem skeleton esticando
        // no meio da animação).
        const idle = window.requestIdleCallback || ((fn) => setTimeout(fn, 800));
        idle(() => {
          if (!this.hydrated) {
            this.hydrate();
            this.hydrated = true;
          }
        });
      }

      disconnectedCallback() {
        if (this.openHandler) {
          document.removeEventListener('click', this.openHandler);
        }
        if (this.offerAddedHandler) {
          document.removeEventListener('rafobase:offer:added', this.offerAddedHandler);
        }
        if (window.__rfDrawers) {
          window.__rfDrawers.delete(this.drawerId);
        }
      }

      open() {
        if (this.dialog.open) return;
        this.dialog.showModal();
        document.documentElement.style.overflow = 'hidden';
        if (!this.hydrated) {
          this.hydrate();
          this.hydrated = true;
        }
      }

      close() {
        if (!this.dialog.open || this.dialog.classList.contains('is-closing')) return;
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (reduceMotion) {
          this.dialog.close();
          return;
        }
        // Saída animada: classe dispara os keyframes de out do painel e do
        // backdrop; o dialog.close() real só roda no fim (fallback de timeout
        // cobre animationend perdido).
        this.dialog.classList.add('is-closing');
        const panel = this.dialog.querySelector('.rf-offer-drawer__panel');
        let finished = false;
        const done = () => {
          if (finished) return;
          finished = true;
          this.dialog.classList.remove('is-closing');
          this.dialog.close();
        };
        panel.addEventListener('animationend', done, { once: true });
        setTimeout(done, 400);
      }

      hydrate() {
        // Lê o JSON de kits injetado pelo app embed
        const kitsScript = document.getElementById('rafobase-kits');
        if (!kitsScript) {
          console.error('[RF-007] #rafobase-kits não encontrado. App embed "Rafobase Cart" habilitado?');
          return;
        }
        let kitsData;
        try {
          kitsData = JSON.parse(kitsScript.textContent);
        } catch (err) {
          console.error('[RF-007] Falha ao parsear #rafobase-kits:', err);
          return;
        }

        this.plans.forEach((plan) => this.hydratePlan(plan, kitsData));
      }

      async hydratePlan(planEl, kitsData) {
        const slug = planEl.dataset.slug;
        const container = planEl.querySelector('[data-components]');
        if (!container) return;

        const kit = kitsData[slug];
        if (!kit) {
          console.warn('[RF-007] Kit não encontrado no #rafobase-kits:', slug);
          container.innerHTML = '';
          return;
        }

        const products = Array.isArray(kit.products) ? kit.products : [];
        const freebies = Array.isArray(kit.freebies) ? kit.freebies : [];
        const isRecurring = !!kit.frequency;
        const monthlyPrice = Number(planEl.dataset.monthlyPrice || 0);

        // Coleta GIDs pra fetchar
        const allItems = [
          ...products.map((p, i) => ({ ...p, __role: i === 0 ? 'main' : 'component' })),
          ...freebies.map((f) => ({ ...f, __role: 'freebie' })),
        ];

        try {
          const variantsData = await Promise.all(
            allItems.map(async (it) => {
              const id = gidToId(it.variantId);
              if (!id) return { ...it, __product: null, __name: '', __image: '' };
              try {
                const { product, name, image } = await resolveVariant(id);
                return { ...it, __product: product, __name: name, __image: image };
              } catch (err) {
                console.warn('[RF-007] Falha ao resolver variante:', id, err);
                return { ...it, __product: null, __name: '', __image: '' };
              }
            }),
          );

          const html = variantsData
            .map((item) =>
              this.renderComponent(item, {
                isRecurring,
                monthlyPrice,
                frequency: kit.frequency,
              }),
            )
            .join('');
          container.innerHTML = html;
        } catch (err) {
          console.error('[RF-007] Falha ao hidratar plano:', slug, err);
          container.innerHTML = '';
        }
      }

      renderComponent(item, ctx) {
        const role = item.__role;
        const qty = item.qty || 1;
        const name = item.__name || '';
        const imgSrc = item.__image || '';

        // Textos configuráveis: settings do block via data-attrs do root
        const labels =
          this.labels ||
          (this.labels = {
            free: this.dataset.labelFree || 'Grátis',
            firstOrder: this.dataset.labelFirstOrder || 'Apenas na primeira entrega',
            copyTemplate: this.dataset.copyTemplate || '',
          });

        let priceHtml = '';
        let extraClass = '';
        let badgeHtml = '';

        if (role === 'main') {
          const suffix = ctx.isRecurring ? '<span class="rf-drawer-component__price-suffix">/mês</span>' : '';
          priceHtml =
            '<span class="rf-drawer-component__price">' + this.escape(moneyBRL(ctx.monthlyPrice)) + suffix + '</span>';
        } else if (role === 'freebie') {
          extraClass = 'rf-drawer-component--freebie';
          badgeHtml = '<span class="rf-drawer-component__badge">' + this.escape(labels.free) + '</span>';
          // Preço original riscado — pega o price da variante correspondente do produto
          const product = item.__product;
          let original = 0;
          if (product && Array.isArray(product.variants)) {
            const variantId = gidToId(item.variantId);
            const variant = product.variants.find((v) => String(v.id) === String(variantId));
            if (variant && variant.price) {
              // /products.json retorna price como string decimal ("168.00")
              original = Number(variant.price);
            }
          }
          if (original > 0) {
            priceHtml =
              '<span class="rf-drawer-component__price rf-drawer-component__price--strike">' +
              this.escape(moneyBRL(original)) +
              '</span>';
          }
        }
        // role === 'component' → sem preço (parte do plano)

        // Copy do item: description do Rafobase (products[]/freebies[] — THEME_API
        // §4.2) vence; sem ela, deriva do template configurável ({qtd}/{dias}) no
        // item principal e do label de 1ª entrega no freebie.
        const FREQ_DAYS = { S: 7, Q: 15, M: 30, B: 60, T: 90 };
        const metaBits = [];
        if (item.description) {
          metaBits.push(item.description);
        } else if (role === 'freebie') {
          if (item.firstOrderOnly) metaBits.push(labels.firstOrder);
        } else if (role === 'main' && ctx.isRecurring && labels.copyTemplate) {
          const days = FREQ_DAYS[ctx.frequency] || 30;
          metaBits.push(labels.copyTemplate.replace(/\{qtd\}/g, String(qty)).replace(/\{dias\}/g, String(days)));
        }
        const metaHtml = metaBits.length
          ? '<span class="rf-drawer-component__meta">' + this.escape(metaBits.join(' · ')) + '</span>'
          : '';

        const check =
          '<svg class="rf-drawer-component__check" width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true"><circle cx="7" cy="7" r="7" fill="currentColor"/><path d="M4 7L6 9L10 5" stroke="#fff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';

        const imgHtml = imgSrc
          ? '<img class="rf-drawer-component__img" src="' + this.escape(imgSrc) + '" alt="" loading="lazy"/>'
          : '<span class="rf-drawer-component__img" aria-hidden="true"></span>';

        // Só <span> aqui: o markup é injetado dentro de <span data-components>,
        // que vive num <button> — <div> seria HTML inválido (phrasing content).
        return (
          '<span class="rf-drawer-component ' +
          extraClass +
          '">' +
          imgHtml +
          '<span class="rf-drawer-component__body">' +
          // Preço na mesma linha do nome, e não numa terceira coluna: assim a
          // meta embaixo usa a largura inteira do corpo em vez de quebrar
          // cedo num vão estreito.
          '<span class="rf-drawer-component__top">' +
          check +
          '<span class="rf-drawer-component__name">' +
          this.escape(name) +
          '</span>' +
          badgeHtml +
          (priceHtml ? '<span class="rf-drawer-component__price-wrap">' + priceHtml + '</span>' : '') +
          '</span>' +
          metaHtml +
          '</span>' +
          '</span>'
        );
      }

      escape(str) {
        return String(str)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;')
          .replace(/'/g, '&#39;');
      }

      select(plan) {
        this.plans.forEach((p) => {
          const on = p === plan;
          p.classList.toggle('is-selected', on);
          p.setAttribute('aria-checked', on ? 'true' : 'false');
        });
        this.selected = plan;
        this.updateGuarantee(plan);
      }

      // O prazo da garantia muda por tipo de plano: assinatura (mensal ou
      // trimestral) e compra única têm textos próprios, os dois já no DOM.
      // Aqui só trocamos qual está visível — o resto é copy do editor.
      updateGuarantee(plan) {
        if (!this.guarantee || !plan) return;
        const isOnetime = plan.classList.contains('rf-drawer-plan--single') || !plan.dataset.frequency;
        const mode = isOnetime ? 'onetime' : 'subscription';
        if (this.guarantee.dataset.mode === mode) return;
        this.guarantee.dataset.mode = mode;
        this.guaranteeVariants.forEach((variant) => {
          variant.hidden = variant.dataset.guaranteeMode !== mode;
        });
      }

      async handleCheckout() {
        if (!this.selected || this.isProcessing) return;
        const slug = this.selected.dataset.slug;

        if (!window.RafobaseCart || typeof window.RafobaseCart.addOffer !== 'function') {
          console.error(
            '[RF-007] window.RafobaseCart.addOffer não disponível. ' +
              'Habilite o app embed "Rafobase Cart" em Personalizar tema → App embeds.',
          );
          this.cta.disabled = true;
          return;
        }

        this.isProcessing = true;
        this.cta.disabled = true;
        this.cta.dataset.loading = 'true';

        let failed = false;
        try {
          await window.RafobaseCart.addOffer(slug);
          // addOffer já rodou o /cart/add.js (product_added_to_cart do Web Pixel) e
          // disparou rafobase:offer:added ANTES de resolver — nenhum evento se perde.
          if (this.checkoutFlow === 'direct') {
            // Vai direto ao checkout em vez de abrir o carrinho. O checkout_started
            // (InitiateCheckout / begin_checkout) dispara no carregamento do /checkout,
            // então esse evento também continua. Mantém o loading até a página trocar.
            this.redirecting = true;
            window.location.href = '/checkout';
            return;
          }
          // Fluxo padrão: rafobase:offer:added fecha o drawer e o app abre o carrinho.
        } catch (err) {
          failed = true;
          console.error('[RF-007] addOffer rejeitado:', err);
          setTimeout(() => {
            this.cta.disabled = false;
          }, 1500);
        } finally {
          this.isProcessing = false;
          // Em redirect, preserva o loading até a navegação (não reabilita nem some o "…").
          if (!this.redirecting) {
            delete this.cta.dataset.loading;
            // Fail-closed: no erro, mantém desabilitado — o catch já programou a reabilitação (1500ms)
            if (!failed) {
              this.cta.disabled = false;
            }
          }
        }
      }
    }
    customElements.define('rf-offer-drawer', RFOfferDrawer);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["nuture-sticky-buy-bar"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('rf-buy-sticky')) {
    class RFBuySticky extends HTMLElement {
      connectedCallback() {
        // Guard de re-entrância: o portal (appendChild no <body>, abaixo)
        // re-dispara connectedCallback. Sem o guard, todos os listeners
        // duplicariam e o IntersectionObserver antigo vazaria.
        // Precisa ser setado ANTES do reparent.
        if (this._initialized) return;
        this._initialized = true;

        // Se estiver dentro do theme editor (design mode), força visibilidade
        // pra marketing conseguir ver e configurar o bloco.
        if (window.Shopify && window.Shopify.designMode) {
          this.classList.add('is-editor-preview');
        }

        this.cta = this.querySelector('[data-action="checkout"]');
        this.fallbackSlug = this.dataset.fallbackSlug || '';
        this.desktopAction = this.dataset.desktopAction || 'direct';
        this.mobileAction = this.dataset.mobileAction || 'anchor';
        this.triggerScroll = parseInt(this.dataset.triggerScroll, 10) || 300;
        this.drawerId = this.dataset.drawerId || 'rf-offer-drawer';
        this.isProcessing = false;

        // Se qualquer breakpoint usa a ação "drawer", adiciona o atributo
        // data-rf-drawer-open no CTA. O RF-007 escuta cliques globalmente
        // procurando por esse atributo — zero código adicional aqui.
        // Detecta em runtime qual breakpoint está ativo pra decidir se ativa.
        this.syncDrawerAttribute();
        this._onResizeSyncDrawer = () => this.syncDrawerAttribute();
        window.addEventListener('resize', this._onResizeSyncDrawer);

        // Portal pattern: move o elemento pra dentro do <body> pra escapar
        // de qualquer containing block do pai (transform/filter/will-change)
        // que quebraria o position: fixed.
        if (!window.Shopify || !window.Shopify.designMode) {
          if (this.parentElement !== document.body) {
            document.body.appendChild(this);
          }
        }

        // Detecta se algum ancestral (incluindo body/html) tem propriedade
        // que cria containing block e quebra position: fixed.
        // Se sim, aplica correção via top calculado (posição real do viewport).
        this.checkContainingBlock();

        // Descoberta do <rf-kit-selector> na página (opcional).
        this.selector = document.querySelector('rf-kit-selector');

        this.setupScrollTrigger();

        if (this.cta) {
          this.cta.addEventListener('click', (e) => this.handleClick(e));
        }
      }

      disconnectedCallback() {
        // O reparent do portal também dispara disconnectedCallback, mas quando
        // as reactions rodam o elemento já foi re-inserido no <body>
        // (isConnected === true). Só limpa na remoção real do DOM.
        if (this.isConnected) return;
        if (this._onResizeSyncDrawer) window.removeEventListener('resize', this._onResizeSyncDrawer);
        if (this._onResizeFallback) window.removeEventListener('resize', this._onResizeFallback);
        if (this._onResizeNoScroll) window.removeEventListener('resize', this._onResizeNoScroll);
        if (this.observer) this.observer.disconnect();
        if (this.sentinel && this.sentinel.parentNode) {
          this.sentinel.parentNode.removeChild(this.sentinel);
        }
      }

      checkContainingBlock() {
        // Verifica se algum ancestral (incluindo body/html) tem propriedades
        // que quebram position:fixed. Vai subindo pelo DOM até o topo.
        const problematicProps = ['transform', 'filter', 'perspective', 'willChange', 'backdropFilter', 'contain'];
        const broken = [];

        // Começa no parent do sticky e sobe até o html
        let current = this.parentElement;
        while (current) {
          const cs = window.getComputedStyle(current);
          for (const prop of problematicProps) {
            const value = cs[prop];
            if (value && value !== 'none' && value !== 'auto' && value !== 'normal') {
              // "contain" só quebra fixed com valor "layout", "paint" ou "strict"
              if (prop === 'contain' && !/layout|paint|strict/i.test(value)) continue;
              broken.push({ target: current.tagName + (current.id ? '#' + current.id : ''), prop, value });
            }
          }
          current = current.parentElement;
        }

        // Também detecta se o body tem altura maior que o viewport E tem overflow
        // que pode indicar layout com wrapper problemático
        const bodyRect = document.body.getBoundingClientRect();
        const shouldForceFallback = broken.length > 0;

        if (shouldForceFallback) {
          console.warn('[RF-004] Containing block detectado — ativando modo fallback:', broken);
          this.classList.add('is-fallback-mode');

          this.applyFallbackPosition();
          // Recalcula em resize (não em scroll — position fixed real ancora sozinho).
          // Referência única e estável: addEventListener deduplica se os dois
          // caminhos (checkContainingBlock e verifyFixedWorks) registrarem.
          if (!this._onResizeFallback) this._onResizeFallback = () => this.applyFallbackPosition();
          window.addEventListener('resize', this._onResizeFallback);
        } else {
          // Verifica após 1 frame se position:fixed está funcionando corretamente
          // (posição real deve estar dentro do viewport)
          requestAnimationFrame(() => this.verifyFixedWorks());
        }
      }

      verifyFixedWorks() {
        // Mede a posição real da sticky com transform neutralizado.
        // Sem isso, o transform: translateY(150%) inicial (estado escondido)
        // faz a medição pensar que o fixed está quebrado — falso positivo.
        const originalTransform = this.style.transform;
        const originalTransition = this.style.transition;

        this.style.transition = 'none';
        this.style.transform = 'translateY(0)';

        // Força reflow síncrono pra garantir que o transform foi aplicado
        void this.offsetHeight;

        const rect = this.getBoundingClientRect();
        const viewportH = window.innerHeight;

        // Restaura estilos originais
        this.style.transform = originalTransform;
        this.style.transition = originalTransition;

        // Tolerância pequena (30px) — se a sticky está mais que isso fora
        // do viewport, o position:fixed não está ancorado corretamente.
        // Casos típicos: LPs com wrappers que criam containing block
        // (transform, filter, contain, will-change em algum ancestral).
        // Com transform neutralizado acima, o único motivo de rect.bottom
        // ficar significativamente além do viewport é containing block real.
        if (rect.bottom > viewportH + 30) {
          console.warn(
            '[RF-004] position:fixed não ancorado no viewport ' +
              `(rect.bottom=${rect.bottom}, viewport=${viewportH}, diff=${rect.bottom - viewportH}px). ` +
              'Ativando fallback.',
          );
          this.classList.add('is-fallback-mode');
          this.applyFallbackPosition();
          // Recalcula em resize (não em scroll — fixed ancora sozinho no viewport)
          if (!this._onResizeFallback) this._onResizeFallback = () => this.applyFallbackPosition();
          window.addEventListener('resize', this._onResizeFallback);
        }
      }

      applyFallbackPosition() {
        // Fallback: se o containing block real quebra fixed, tenta forçar
        // via top calculado do VIEWPORT (não do documento).
        // Como position: fixed em containing block quebrado se comporta como
        // absolute em relação ao ancestral, calculamos onde o "bottom: 16px"
        // deveria estar em coordenadas do containing block.
        const bottomOffset = 16;
        const viewportH = window.innerHeight;
        const stickyH = this.offsetHeight || 80;

        // Tenta manter position:fixed (mais performático), com top calculado
        this.style.setProperty('position', 'fixed', 'important');
        this.style.setProperty('top', `${viewportH - stickyH - bottomOffset}px`, 'important');
        this.style.setProperty('bottom', 'auto', 'important');
      }

      setupScrollTrigger() {
        // No modo editor, ignora trigger (força visível pra config)
        if (this.classList.contains('is-editor-preview')) {
          return;
        }

        // Estratégia 0 (mais forte): seção marcada no theme editor com
        // "Esta seção libera a barra fixa" (setting rm_sticky_trigger da
        // "Nuture · Seção"). Ganha das outras duas porque é escolha explícita
        // de quem montou a página — nas listicles é o 4º item da lista.
        // Se mais de uma seção estiver marcada, vale a primeira do documento.
        this.trigger = document.querySelector('[data-nuture-sticky-trigger]');
        if (this.trigger) {
          const mode = this.trigger.getAttribute('data-nuture-sticky-trigger');
          this.observer = new IntersectionObserver(
            (entries) => {
              // A direção importa: !isIntersecting sozinho também é verdade
              // quando a seção ainda está ABAIXO da dobra, e a barra apareceria
              // no topo da página. Por isso a decisão sai da geometria.
              //   "at"    → topo da seção encostou na base da tela: ela começou.
              //   "after" → base da seção passou do topo da tela: ela acabou.
              const rect = entries[0].boundingClientRect;
              const passed = mode === 'after' ? rect.bottom <= 0 : rect.top <= window.innerHeight;
              this.classList.toggle('is-visible', passed);
            },
            { threshold: 0 },
          );
          this.observer.observe(this.trigger);
          return;
        }

        // Estratégia 1 (preferida): observa o RF-003 na página.
        // Sticky aparece quando o seletor SAI do viewport.
        // É semanticamente correto — sticky substitui o CTA do seletor.
        if (this.selector) {
          this.observer = new IntersectionObserver(
            (entries) => {
              const entry = entries[0];
              this.classList.toggle('is-visible', !entry.isIntersecting);
            },
            {
              threshold: 0,
              // Margem: aparece assim que o seletor sai da tela pelo topo,
              // e some quando ele volta a aparecer.
              rootMargin: '0px 0px -50px 0px',
            },
          );
          this.observer.observe(this.selector);
          return;
        }

        // Estratégia 2 (fallback): sentinela em posição fixa de pixels.
        // Usado quando não há RF-003 na página (LPs standalone).
        this.sentinel = document.createElement('div');
        this.sentinel.style.position = 'absolute';
        this.sentinel.style.top = this.triggerScroll + 'px';
        this.sentinel.style.left = '0';
        this.sentinel.style.width = '1px';
        this.sentinel.style.height = '1px';
        this.sentinel.style.pointerEvents = 'none';
        this.sentinel.setAttribute('aria-hidden', 'true');
        document.body.appendChild(this.sentinel);

        this.observer = new IntersectionObserver(
          (entries) => {
            const entry = entries[0];
            this.classList.toggle('is-visible', !entry.isIntersecting);
          },
          { threshold: 0 },
        );

        this.observer.observe(this.sentinel);

        // Fallback pra páginas que cabem inteiras na tela (LPs curtas no desktop):
        // se não há scroll possível, o sentinela nunca sai do viewport e a
        // sticky nunca apareceria. Nesse caso, mostra imediatamente após um
        // pequeno delay (pra dar tempo do usuário ver o conteúdo primeiro).
        this.checkNoScrollFallback();
        this._onResizeNoScroll = () => this.checkNoScrollFallback();
        window.addEventListener('resize', this._onResizeNoScroll);
      }

      checkNoScrollFallback() {
        // Se scrollHeight <= innerHeight, não há como rolar. Mostra sticky
        // direto após 800ms (dá tempo do usuário ver o hero antes).
        const canScroll = document.documentElement.scrollHeight > window.innerHeight + 10;
        if (!canScroll && !this._noScrollTimeoutId) {
          this._noScrollTimeoutId = setTimeout(() => {
            // Só ativa se ainda não há scroll (usuário pode ter feito algo entre)
            const stillCantScroll = document.documentElement.scrollHeight <= window.innerHeight + 10;
            if (stillCantScroll) {
              this.classList.add('is-visible');
            }
          }, 800);
        } else if (canScroll && this._noScrollTimeoutId) {
          // Se de repente há scroll (imagens carregaram, JS adicionou conteúdo),
          // cancela o auto-show — deixa o IntersectionObserver assumir.
          clearTimeout(this._noScrollTimeoutId);
          this._noScrollTimeoutId = null;
        }
      }

      currentAction() {
        const isMobile = window.matchMedia('(max-width: 749px)').matches;
        return isMobile ? this.mobileAction : this.desktopAction;
      }

      syncDrawerAttribute() {
        // Se a ação ativa é "drawer", adiciona o atributo que o RF-007 escuta.
        // Se for outra ação, remove pra não interferir.
        // Isso é reavaliado no resize pra caso desktop e mobile tenham
        // ações diferentes (ex: desktop=direct, mobile=drawer).
        if (!this.cta) return;
        const action = this.currentAction();
        if (action === 'drawer') {
          this.cta.setAttribute('data-rf-drawer-open', this.drawerId);
        } else {
          this.cta.removeAttribute('data-rf-drawer-open');
        }
      }

      resolveSlug() {
        if (this.selector && typeof this.selector.selectedSlug === 'string' && this.selector.selectedSlug) {
          return this.selector.selectedSlug;
        }
        return this.fallbackSlug || null;
      }

      handleClick(e) {
        const action = this.currentAction();

        // O <a> resolve sozinho — sair antes até do guard de isProcessing,
        // que só existe pro fluxo de carrinho.
        if (action === 'link') return;

        // Se o CTA nasceu <a> porque o OUTRO breakpoint pede link, aqui a ação
        // é outra: segurar a navegação antes de tratar.
        if (e && this.cta.tagName === 'A') e.preventDefault();

        if (this.isProcessing) return;

        if (action === 'anchor') {
          this.scrollToSelector();
        } else if (action === 'drawer') {
          // Não faz nada aqui — o RF-007 escuta o clique globalmente via
          // atributo data-rf-drawer-open (sincronizado em syncDrawerAttribute).
          // Se o RF-007 não estiver na página, o clique não faz nada.
          // Log opcional pra debug.
          if (!document.getElementById(this.drawerId)) {
            console.warn(
              `[RF-004] Ação "drawer" configurada mas RF-007 com id "${this.drawerId}" ` +
                'não encontrado na página. Adicione o bloco RF-007 pra o clique funcionar.',
            );
          }
        } else {
          this.addToCart();
        }
      }

      scrollToSelector() {
        if (this.selector) {
          this.selector.scrollIntoView({ behavior: 'smooth', block: 'center' });
          return;
        }
        const anchor = document.querySelector('#buy-section, .product-form, product-form-component');
        if (anchor) {
          anchor.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }

      async addToCart() {
        const slug = this.resolveSlug();

        // Sem offer_group resolvido (nem seletor de kit na página, nem slug de
        // fallback) — caso típico de PDP comum, onde o seletor RF-003 está
        // desligado e o botão de compra é o product-form nativo do Horizon.
        // Em vez de morrer, adiciona a variante desse product-form no carrinho
        // nativo da Shopify, igual ao botão "Comprar agora". Nas LPs o slug
        // resolve e o fluxo Rafobase abaixo segue idêntico.
        if (!slug) {
          this.addViaProductForm();
          return;
        }

        if (!window.RafobaseCart || typeof window.RafobaseCart.addOffer !== 'function') {
          console.error(
            '[RF-004] window.RafobaseCart.addOffer não disponível. Habilite o app embed "Rafobase Cart" em Personalizar tema → App embeds.',
          );
          this.cta.disabled = true;
          return;
        }

        this.isProcessing = true;
        this.cta.disabled = true;
        this.cta.dataset.loading = 'true';

        try {
          await window.RafobaseCart.addOffer(slug);
        } catch (err) {
          console.error('[RF-004] addOffer rejeitado:', err);
          setTimeout(() => {
            this.cta.disabled = false;
          }, 1500);
        } finally {
          this.isProcessing = false;
          delete this.cta.dataset.loading;
          setTimeout(() => {
            this.cta.disabled = false;
          }, 300);
        }
      }

      // Aciona o <product-form-component> nativo da página — o mesmo caminho do
      // botão "Comprar agora". Reaproveita variante selecionada, quantidade,
      // selling plan, validação e a abertura do cart drawer do Horizon (o
      // componente escuta on:submit="/handleSubmit"). Usado quando não há
      // offer_group pra passar pro RafobaseCart (PDP comum sem seletor de kit).
      addViaProductForm() {
        const form = this.findProductForm();
        if (!form) {
          console.warn(
            '[RF-004] Sem offer_group e sem <product-form-component> na página — nada pra adicionar ao carrinho.',
          );
          return;
        }

        this.isProcessing = true;
        this.cta.disabled = true;
        this.cta.dataset.loading = 'true';

        // requestSubmit dispara o evento "submit" (que o product-form-component
        // escuta); form.submit() NÃO dispararia o evento e faria um POST de
        // página inteira pra /cart/add.
        if (typeof form.requestSubmit === 'function') {
          form.requestSubmit();
        } else {
          const submitBtn = form.querySelector('[type="submit"]');
          if (submitBtn) submitBtn.click();
        }

        this.isProcessing = false;
        delete this.cta.dataset.loading;
        // Reabilita depois de um instante — daí o cart drawer do Horizon assume.
        setTimeout(() => {
          this.cta.disabled = false;
        }, 600);
      }

      // Acha o form de compra da página. Prefere o primeiro
      // <product-form-component> visível (a seção principal do produto); por
      // último, qualquer form que poste em /cart/add.
      findProductForm() {
        const components = Array.from(document.querySelectorAll('product-form-component'));
        for (const component of components) {
          const form = component.querySelector('form[action*="/cart/add"]') || component.querySelector('form');
          if (form && component.getBoundingClientRect().width > 0) return form;
        }
        return document.querySelector('form[action*="/cart/add"]');
      }
    }

    customElements.define('rf-buy-sticky', RFBuySticky);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["subscription-selector"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('subscription-selector')) {
    class SubscriptionSelector extends HTMLElement {
      connectedCallback() {
        this.options = Array.from(this.querySelectorAll('.subscription-option'));
        this.sectionRoot = this.closest('.shopify-section, dialog') || document;
        this.selected = null;

        this.options.forEach((opt) => {
          opt.addEventListener('click', () => {
            if (opt.dataset.soldout === 'true') return;
            this.select(opt);
          });
        });

        // Seleção inicial: plano padrão, senão primeiro disponível.
        const wanted = this.dataset.defaultPlan;
        let initial =
          this.options.find((o) => o.dataset.plan === wanted && o.dataset.variantId && o.dataset.soldout !== 'true') ||
          this.options.find((o) => o.dataset.variantId && o.dataset.soldout !== 'true') ||
          this.options.find((o) => o.dataset.variantId);
        if (initial) this.select(initial);

        // Garante que a variante escolhida seja enviada ao carrinho.
        if (this.dataset.syncBuyButton === 'true') this.bindForm();
      }

      get form() {
        return (
          this.sectionRoot.querySelector('product-form-component form[action*="/cart"]') ||
          this.sectionRoot.querySelector('form[action*="/cart/add"]')
        );
      }

      select(opt) {
        this.options.forEach((o) => {
          const on = o === opt;
          o.classList.toggle('is-selected', on);
          o.setAttribute('aria-checked', on ? 'true' : 'false');
        });
        this.selected = opt;
        const id = opt.dataset.variantId;
        if (id) this.applyVariant(id);
      }

      applyVariant(id) {
        const form = this.form;
        if (form) {
          let input = form.querySelector('input[name="id"]');
          if (!input) {
            input = document.createElement('input');
            input.type = 'hidden';
            input.name = 'id';
            form.appendChild(input);
          }
          if (input.value !== id) {
            input.value = id;
            input.dispatchEvent(new Event('input', { bubbles: true }));
            input.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
        // Mantém a URL com a variante selecionada (sem recarregar).
        try {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', id);
          window.history.replaceState({}, '', url);
        } catch (e) {}
      }

      bindForm() {
        const form = this.form;
        if (!form) return;
        const forceId = () => {
          if (!this.selected) return;
          const id = this.selected.dataset.variantId;
          if (!id) return;
          const input = form.querySelector('input[name="id"]');
          if (input) input.value = id;
        };
        // Captura antes do handler do tema, garantindo o id correto no envio.
        form.addEventListener('submit', forceId, true);
        const addBtn = form.querySelector('[type="submit"], [name="add"]');
        if (addBtn) addBtn.addEventListener('click', forceId, true);
      }
    }
    customElements.define('subscription-selector', SubscriptionSelector);
  }
  } catch(e) { console.error(e); }
})();

})();
